/*
 * @Author: 张印 hbzyin@163.com
 * @Date: 2023-07-27 19:21:22
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-10-22 15:16:55
 * @FilePath: /mall-fe/src/comps/ImgTag.tsx
 * @Description: 图片展示组件
 *
 */
import PlaceholderImage from 'comps/PlaceholderImage';
import { DeviceContext, PriceContext } from 'libs/contexts';
import { formatPrice } from 'libs/utils';
import { useContext } from 'react';
type ImgTagProps = {
  width: number;
  height: number;
  image: string;
  tag?: string;
  borderRadius?: number;
  titleName?: string;
  borderTopLeftRadius?: number;
  borderTopRightRadius?: number;
};

export default function ImgTag({
  width,
  height,
  image,
  tag,
  borderRadius = 6,
  titleName,
  borderTopLeftRadius = 0,
  borderTopRightRadius = 0,
}: ImgTagProps) {
  const { buildImgSrc } = useContext(DeviceContext);
  return (
    <div
      className="img-box"
      style={{
        width: `${width}px`,
        height: `${height}px`,
        borderTopLeftRadius: `${borderTopLeftRadius ? borderTopLeftRadius : borderRadius}px`,
        borderTopRightRadius: `${borderTopRightRadius ? borderTopRightRadius : borderRadius}px`,
      }}
    >
      <PlaceholderImage height={height} width={width} src={buildImgSrc(image)} />
      {!!tag && <span className="img-tag">{tag}</span>}
      {titleName && (
        <>
          <span className="img-title">{titleName}</span>
          <i className="bottom_line" />
        </>
      )}
      <style jsx>{`
        .img-box {
          position: relative;
          border-radius: ${borderRadius}px;
          overflow: hidden;
        }
        .img-tag {
          position: absolute;
          top: 0;
          left: 0;
          background: rgba(245, 34, 45, 0.9);
          border-radius: 3px 0 0 0;
          padding: 0px 5px;
          color: #fff;
          font-size: 12px;
        }
        .img-title {
          position: absolute;
          top: 20px;
          left: 20px;
          color: #fff;
          font-size: 20px;
          font-weight: 600;
          line-height: 27px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 95%;
        }
        .bottom_line {
          position: absolute;
          top: 55px;
          left: 20px;
          width: 32px;
          height: 3px;
          background-color: #fff;
        }
      `}</style>
    </div>
  );
}

export function NameTag({
  name,
  tag,
  lineHeight = 20,
}: {
  name: string;
  tag?: string;
  lineHeight?: number;
}) {
  return (
    <div className="name" style={{ height: `${lineHeight * 2}px`, lineHeight: `${lineHeight}px` }}>
      {!!tag && <span className="name-tag">{tag}</span>}
      {name}
      <style jsx>{`
        .name {
          color: #333;
          font-weight: 400;
          font-size: 14px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .name-tag {
          border: 1px solid var(--primaryColor);
          color: #fff;
          padding: 0px 2px;
          background-color: var(--primaryColor);
          border-radius: 1px;
          font-size: 12px;
          margin-right: 3px;
          display: inline-block;
          -webkit-transform: translateY(-1px);
          -ms-transform: translateY(-1px);
          transform: translateY(-1px);
          line-height: 15px;
        }
      `}</style>
    </div>
  );
}

export function FmPriceStr({ price, marginTop = 17 }: { price: number; marginTop?: number }) {
  const priceData = useContext(PriceContext);
  const { showPrice, tip } = priceData;

  const salePrice = formatPrice(price);
  return (
    <div className="price" style={{ marginTop: `${marginTop}px` }}>
      {showPrice ? <>&yen;{salePrice}</> : <>{tip}</>}
      <style jsx>{`
        .price {
          font-size: 16px;
          line-height: 16px;
          font-weight: 500;
          color: #fa5401;
        }
      `}</style>
    </div>
  );
}
